import { connect } from 'react-redux';
import { isEmpty, isNil, omitBy } from 'lodash';
import { logger } from '@fiverr-private/obs';
import {
    reportIndustrySelectionChangeEvent,
    reportIndustrySelectionClickEvent,
} from '../../../../utils/reports/filter/IndustryFilter';
import { getCurrentUserIndustries, getMostCommonIndustries, toggleIndustrySelection } from '../../../../store/actions';
import IndustrySelection from './IndustrySelection';

export const TYPES = {
    industrySelectionChange: {
        BigQuery: 'applied_industry_filter',
        Mixpanel: 'Industry Selection Clicked',
    },
    industrySelectionClick: {
        BigQuery: 'clicked_on_industry_filter',
    },
};

const mapStateToProps = (state) => {
    const currentUserIndustries = getCurrentUserIndustries(state);
    const commonIndustries = getMostCommonIndustries(state);

    const filterCurrentIndustryFunc = (value, key) =>
        !isEmpty(currentUserIndustries) && !isNil(currentUserIndustries[key]);

    const mostCommonIndustriesFiltered = omitBy(commonIndustries, filterCurrentIndustryFunc);
    return {
        currentUserIndustries,
        commonIndustries: mostCommonIndustriesFiltered,
        selected: state.industryDropdownSelected,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onChange: (value) => {
        dispatch(toggleIndustrySelection(value))
            .then((eventData = {}) => {
                reportIndustrySelectionChangeEvent(TYPES.industrySelectionChange, { ...eventData });
            })
            .catch((error) => {
                logger.error(error, {
                    func: 'onChange',
                    component: 'IndustrySelection',
                });
            });
    },
    onClick: () => reportIndustrySelectionClickEvent(TYPES.industrySelectionClick),
});

export default connect(mapStateToProps, mapDispatchToProps)(IndustrySelection);
